import React from "react";

function KYCVector() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="144"
      height="181"
      viewBox="0 0 144 181"
      fill="none"
    >
      <path
        d="M143.227 0.545258H29.8645V162.326H143.227V0.545258Z"
        fill="white"
      />
      <path
        d="M143.275 162.372H29.8159V0.5H143.275V162.372ZM29.9119 162.278H143.181V0.593484H29.9119V162.278Z"
        fill="#231F20"
      />
      <path
        d="M111.414 24.4598H62.7307V53.8244H111.414V24.4598Z"
        fill="#E4E4E4"
      />
      <path
        d="M78.6259 41.2114H95.6277C98.3008 41.2114 100.474 43.3818 100.474 46.0575V54.0214H73.7798V46.0575C73.7798 43.3843 75.9502 41.2114 78.6259 41.2114Z"
        fill="#4E4949"
      />
      <path
        d="M83.7375 34.3136C83.6289 34.5106 82.9719 42.4923 82.9719 42.4923L85.4758 43.4954C87.4946 44.3039 89.8621 43.8137 91.2871 42.2952L90.3017 34.8063L83.7375 34.3136Z"
        fill="#FFD7D7"
      />
      <path
        d="M82.2065 23.5729L79.2528 28.894C79.2528 28.894 77.4665 27.1405 77.1507 28.894C76.2992 33.6238 79.1189 32.876 79.6798 32.6587C80.2382 32.4414 82.6588 36.6861 84.0686 37.4669C85.4911 38.2552 89.8117 38.8969 91.6713 37.0247C93.5309 35.1525 94.4051 34.2656 94.5163 33.5758C94.6249 32.8861 94.0792 34.7583 95.719 33.0831C97.3587 31.408 94.7134 29.6216 93.8038 30.175C92.8942 30.7283 94.6249 28.6464 95.062 26.8727C95.4991 25.099 92.5455 23.818 90.5772 25.4931C88.609 27.1683 82.209 23.5704 82.209 23.5704L82.2065 23.5729Z"
        fill="#FFD7D7"
      />
      <path
        d="M77.1453 28.5681C77.1453 28.5681 74.4368 21.9963 78.5931 20.9124C82.7494 19.8285 81.8752 19.3358 84.5004 18.646C87.1256 17.9562 93.144 18.5474 93.2526 20.7153C93.3613 22.8832 97.7374 21.7992 97.1917 23.9671C96.6459 26.1349 96.9441 31.7567 95.989 31.1604C94.5665 30.2736 93.6923 31.7516 93.144 29.4853C92.5957 27.2189 91.8731 27.8834 88.2221 28.4999C84.7202 29.0911 84.2831 25.1496 82.095 27.2189C79.9069 29.2882 80.5639 30.3721 79.0327 29.2882C77.5016 28.2043 77.1478 28.5681 77.1478 28.5681H77.1453Z"
        fill="#221F1F"
      />
      <path
        d="M126.213 78.8838H45.3829C44.8499 78.8838 44.4177 79.3159 44.4177 79.849V83.0224C44.4177 83.5555 44.8499 83.9876 45.3829 83.9876H126.213C126.746 83.9876 127.178 83.5555 127.178 83.0224V79.849C127.178 79.3159 126.746 78.8838 126.213 78.8838Z"
        fill="#CFCECE"
      />
      <path
        d="M126.213 91.3804H45.3829C44.8499 91.3804 44.4177 91.8125 44.4177 92.3456V95.519C44.4177 96.0521 44.8499 96.4842 45.3829 96.4842H126.213C126.746 96.4842 127.178 96.0521 127.178 95.519V92.3456C127.178 91.8125 126.746 91.3804 126.213 91.3804Z"
        fill="#CFCECE"
      />
      <path
        d="M126.213 103.877H45.3829C44.8499 103.877 44.4177 104.309 44.4177 104.842V108.016C44.4177 108.549 44.8499 108.981 45.3829 108.981H126.213C126.746 108.981 127.178 108.549 127.178 108.016V104.842C127.178 104.309 126.746 103.877 126.213 103.877Z"
        fill="#CFCECE"
      />
      <path
        d="M126.213 116.371H45.3829C44.8499 116.371 44.4177 116.803 44.4177 117.336V120.51C44.4177 121.043 44.8499 121.475 45.3829 121.475H126.213C126.746 121.475 127.178 121.043 127.178 120.51V117.336C127.178 116.803 126.746 116.371 126.213 116.371Z"
        fill="#CFCECE"
      />
      <path
        d="M126.213 128.868H45.3829C44.8499 128.868 44.4177 129.3 44.4177 129.833V133.007C44.4177 133.54 44.8499 133.972 45.3829 133.972H126.213C126.746 133.972 127.178 133.54 127.178 133.007V129.833C127.178 129.3 126.746 128.868 126.213 128.868Z"
        fill="#CFCECE"
      />
      <path
        d="M89.7735 141.365H45.3829C44.8499 141.365 44.4177 141.797 44.4177 142.33V145.503C44.4177 146.037 44.8499 146.469 45.3829 146.469H89.7735C90.3065 146.469 90.7386 146.037 90.7386 145.503V142.33C90.7386 141.797 90.3065 141.365 89.7735 141.365Z"
        fill="#CFCECE"
      />
      <path
        d="M85.8743 75.215C84.7576 75.215 83.6762 74.9952 82.6554 74.5656C81.67 74.1487 80.7857 73.5525 80.0277 72.7945C79.2697 72.0365 78.6734 71.1521 78.2565 70.1668C77.8245 69.1485 77.6072 68.0646 77.6072 66.9478C77.6072 65.831 77.827 64.7496 78.2565 63.7289C78.6734 62.7435 79.2697 61.8592 80.0277 61.1012C80.7857 60.3432 81.67 59.7469 82.6554 59.33C83.6736 58.898 84.7576 58.6807 85.8743 58.6807C86.9911 58.6807 88.0725 58.9005 89.0933 59.33C90.0787 59.7469 90.963 60.3432 91.721 61.1012C92.479 61.8592 93.0753 62.7435 93.4922 63.7289C93.9242 64.7471 94.1415 65.831 94.1415 66.9478C94.1415 68.0646 93.9217 69.146 93.4922 70.1668C93.0753 71.1521 92.479 72.0365 91.721 72.7945C90.963 73.5525 90.0787 74.1487 89.0933 74.5656C88.0751 74.9977 86.9911 75.215 85.8743 75.215ZM85.8743 59.1279C81.5639 59.1279 78.0544 62.6349 78.0544 66.9478C78.0544 71.2608 81.5614 74.7678 85.8743 74.7678C90.1873 74.7678 93.6943 71.2608 93.6943 66.9478C93.6943 62.6349 90.1873 59.1279 85.8743 59.1279Z"
        fill="#2EC19E"
      />
      <path
        d="M83.7547 71.8445L80.604 68.8985L81.1397 68.3249L83.7168 70.7328L90.751 63.1807L91.3245 63.7163L83.7547 71.8445Z"
        fill="#2EC19E"
      />
      <path
        d="M15.542 71.5159H14.9053V69.4845H15.542V71.5159ZM15.024 71.3972H15.4232V69.6033H15.024V71.3972Z"
        fill="#14235A"
      />
      <path
        d="M5.41226 177.711V179.982H2.38029L0.725342 178.342L3.72446 177.986L3.90386 176.998L5.41226 177.711Z"
        fill="#10204C"
      />
      <path
        d="M24.5942 178.1C24.5942 178.1 27.3836 179.755 28.1618 179.656C28.94 179.557 28.1618 180.5 28.1618 180.5L25.6983 180.273L23.4926 179.3V180.305L21.4182 180.338L21.537 178.1H24.5967H24.5942Z"
        fill="#10204C"
      />
      <path
        d="M14.9633 58.4027C14.9633 58.4027 25.2442 61.5635 28.5996 63.7541C31.9549 65.9421 37.6475 68.5218 37.6475 68.5218L47.231 83.9419C47.231 83.9419 49.7122 92.2116 44.5553 91.8225C44.5553 91.8225 34.3401 83.3583 31.7124 78.3479C31.7124 78.3479 34.6307 84.1365 35.702 84.9627C36.7732 85.7889 37.4529 93.864 37.4529 93.864L37.5009 108.604L34.8732 110.065C34.8732 110.065 13.177 111.086 11.1834 108.897C9.18991 106.709 11.7671 96.3957 13.177 95.1324C13.177 95.1324 1.25879 71.6372 6.87804 64.0497C12.4973 56.4622 14.9608 58.4077 14.9608 58.4077L14.9633 58.4027Z"
        fill="#387DF5"
      />
      <path
        d="M42.8043 78.4442L42.0261 77.4234C42.0261 77.4234 44.3607 76.9863 45.5761 79.5635C46.7914 82.1406 44.5048 83.0654 44.5048 83.0654C44.5048 83.0654 43.3046 83.1311 42.8827 81.8652C42.4607 80.5994 42.8018 78.4442 42.8018 78.4442H42.8043Z"
        fill="#FFD7D7"
      />
      <path
        d="M22.9572 61.9553L21.8859 58.5999L25.5824 56.3133V50.7673L24.2686 48.6753C24.2686 48.6753 23.6849 45.2693 22.3711 44.7842C21.0572 44.2966 20.5721 45.1253 20.5721 45.1253L22.5656 49.8426C22.5656 49.8426 21.2037 48.4327 20.5721 49.0644C19.9404 49.696 20.5721 52.5663 20.5721 52.5663C20.5721 52.5663 18.7226 55.3885 17.1182 55.3885H13.4217L12.7395 60.3508L22.9547 61.9553H22.9572Z"
        fill="#FFD7D7"
      />
      <path
        d="M22.5658 45.6583C22.5658 45.6583 25.5321 43.3237 21.545 42.788C21.545 42.788 20.8401 41.5727 19.4302 42.2776C18.0204 42.9826 17.1184 41.8153 16.4134 42.9826C15.7085 44.1499 14.3694 42.2044 13.6644 44.0286C12.9595 45.8528 11.0367 45.1959 11.2818 46.7296C11.5244 48.2607 10.5996 48.7231 11.6709 50.0142C12.7422 51.3028 11.8402 51.985 12.7422 52.9577C13.6417 53.9305 13.1566 56.1691 13.1566 56.1691C13.1566 56.1691 13.3991 56.6567 14.3492 56.5102C15.2966 56.3636 20.6733 54.4661 20.6733 54.4661L21.161 51.28C21.161 51.28 21.4541 49.4078 21.8912 49.6504C22.3283 49.8929 23.0105 50.2593 23.0105 50.2593L23.3036 48.7989L22.3561 46.7801L22.1363 46.0499L22.5734 45.6608L22.5658 45.6583Z"
        fill="#221F1F"
      />
      <path
        d="M35.4086 108.554C35.4086 108.554 32.8541 150.218 30.5928 152.699L24.8295 178.309H21.5449L20.0845 120.012L21.3983 107.702L35.4086 108.554Z"
        fill="#221F1F"
      />
      <path
        d="M12.3505 107.313C12.3505 107.313 10.0891 134.967 9.35895 139.493C8.62875 144.015 2.86548 176.851 2.86548 176.851L6.3674 178.822C6.3674 178.822 14.9049 155.254 14.9049 152.773C14.9049 150.291 20.0845 133.729 20.0845 133.729L21.9088 126.869V108.458L12.3505 107.316V107.313Z"
        fill="#221F1F"
      />
      <path
        d="M21.2544 109.261L10.5642 107.351L11.2742 109.142L21.2544 109.261Z"
        fill="#4E4949"
      />
    </svg>
  );
}

export default KYCVector;
